module.exports = __webpack_public_path__ + "static/media/icon-plus-white.5402e1d8.svg";